import { PropsWithChildren } from 'react'
import AuthContext from '../config/context/auth'
import { useGuild } from '../config/context/guild'
import UnauthorizedInfo from './UnauthorizedInfo'
import { hasAccessToContent } from '../config/permissions'
import { AccessLevel, Section as SectionType } from 'app/frontend/types/custom'

export { hasAccessToContent }

interface Props {
  alwaysRenderContent?: boolean
  requirement?: AccessLevel
  requireAllTeams?: boolean
  renderUnauthorized?: boolean
  section: SectionType
  teamReference?: wowaudit.TeamReference
}

const ProtectedContent = ({
  alwaysRenderContent = false,
  children,
  section,
  requirement = 'member',
  requireAllTeams = false,
  renderUnauthorized = true,
  teamReference,
}: PropsWithChildren<Props>) => {
  const { guild, teamReference: teamRefFromContext } = useGuild()

  const { accessLevel, hasAccess } = hasAccessToContent(
    requirement,
    section,
    guild,
    teamRefFromContext ?? teamReference,
    requireAllTeams,
  )

  if (!hasAccess && !alwaysRenderContent) {
    return renderUnauthorized ? (
      <AuthContext.Provider value={{ accessLevel, section, requirement }}>
        <UnauthorizedInfo teamReference={teamRefFromContext ?? teamReference} />
      </AuthContext.Provider>
    ) : null
  }

  return (
    <AuthContext.Provider value={{ accessLevel, section, requirement }}>
      {children}
    </AuthContext.Provider>
  )
}

export default ProtectedContent
